import { Formation } from "../types"

export const posfor1es: Formation = {
  id: "posfor1es",
  name: "1",
  category: "6 - 5",
  snapshots: [
    {
      players: [
        {
          x: 6.795712998548574,
          y: 7.0924882421641655
        },
        {
          x: 2.7119201514313582,
          y: 4.851753025214447
        },
        {
          x: 10.58693925682077,
          y: 5.543638824134745
        },
        {
          x: 8.012195837825288,
          y: 4.32680330082792
        },
        {
          x: 5.254468291178969,
          y: 3.288424037263385
        },
        {
          x: 12.318199458515345,
          y: 2.549906157535749
        }
      ],
      opponents: [
        {
          x: 8.66837160390765,
          y: 4.789581772816794
        },
        {
          x: 4.301736391858245,
          y: 3.6083096922369697
        },
        {
          x: 5.952770274172547,
          y: 5.841061171664987
        },
        {
          x: 6.526285333302998,
          y: 3.150843794627856
        },
        {
          x: 8.65541898848193,
          y: 3.3525586054174132
        }
      ],
      ball: {
        x: 3.6821356332430275,
        y: 5.255221386252053
      },
      goalkeepers: [
        {
          x: 6.925088223875495,
          y: 0.990639234244325
        }
      ]
    }
  ]
}
